import { AxiosResponse } from "axios";
import axiosInstance from "@lib/axios";
import { DeviceTokenResponse } from "..";

export const resetDeviceToken = async (): Promise<DeviceTokenResponse> => {
    const { data }: AxiosResponse<DeviceTokenResponse> = await axiosInstance.get("auth/user/resetDeviceToken");

    return data;
};
